import React from 'react';
import { DASH_STUDIO_RADIUS } from '../../shared/theme/studio/dashboardConstants';
import { BottomSheetPopup } from '../../components/common/BottomSheetPopup';
import {
  AddressDeliveryAssignmentSheetCore,
  type AddressDeliverySheetChromeProps,
} from './AddressDeliveryAssignmentSheetCore';
import type { AddressDeliveryAssignmentSheetCoreProps } from './AddressDeliveryAssignmentSheetCore';

function SheetChrome({ visible, onClose, title, children, footer }: AddressDeliverySheetChromeProps) {
  return (
    <BottomSheetPopup
      visible={visible}
      onClose={onClose}
      title={title}
      showDragHandle
      animationType="slide"
      sheetHeightMode="fitContent"
      frostedSheetHeader
      sheetTopBorderRadius={DASH_STUDIO_RADIUS}
      sheetStyle={{ maxHeight: '88%' }}>
      {children}
      {footer}
    </BottomSheetPopup>
  );
}

export type AddressDeliveryAssignmentSheetProps = Omit<AddressDeliveryAssignmentSheetCoreProps, 'SheetChrome'>;

export function AddressDeliveryAssignmentSheet(props: AddressDeliveryAssignmentSheetProps) {
  return <AddressDeliveryAssignmentSheetCore {...props} SheetChrome={SheetChrome} />;
}

export default AddressDeliveryAssignmentSheet;
